import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Checkbox } from '../../../form';
import { useNewStrategyContext } from '../../NewStrategyContext';
import { TFlow } from '../../../../types/model';
import { useUserStrategies } from '../../../../context/UserStrategies';

type StartOption = {
  title: string;
  flow: TFlow;
};

export const Start = () => {
  const { t } = useTranslation();

  const options: StartOption[] = [
    {
      title: t('strategies.newStrategy.start.startFromScratch'),
      flow: 'SCRATCH',
    },
    {
      title: t('strategies.newStrategy.start.duplicate'),
      flow: 'CLONE',
    },
  ];

  const { draftStrategy, draftCloneStrategy } = useUserStrategies();
  const { flow, setFlow, dispatch } = useNewStrategyContext();

  useEffect(() => {
    dispatch({ isDisabledNext: false });
  }, []);

  return (
    <div className="flex flex-col w-96 m-auto items-center text-black">
      <span className="text-xl font-medium mb-5 dark:text-white">
        {t('strategies.newStrategy.start.title')}
      </span>

      <span className="w-full text-center text-sm text-grey-50 font-light">
        {t('strategies.newStrategy.start.subtitle')}
      </span>

      {options.map((option, index) => (
        <div
          key={option.title}
          className={`
            flex
            h-16
            w-full
            rounded-xl
            border
            border-grey-10
            mt-5
            items-center
            justify-between
            shadow-md
            text-sm
            font-medium
            px-5
            dark:text-white
          `}
        >
          <div>
            <Checkbox
              className="mr-2"
              onClick={() => setFlow!(option.flow)}
              value={option}
              isCheck={option.flow === flow}
            />
            {option.title}
          </div>
          {(option.flow === 'CLONE' && draftCloneStrategy) ||
          (option.flow === 'SCRATCH' && draftStrategy) ? (
            <div
              className={
                'ml-2 bg-grey-30 inline-flex items-center text-xs justify-center rounded-xl px-2 py-0.5'
              }
            >
              {t('strategies.newStrategy.draft')}
            </div>
          ) : (
            <></>
          )}
        </div>
      ))}
    </div>
  );
};
